import * as Dialog from '@radix-ui/react-dialog'

/**
 * Modal — centered dialog over a dim scrim. Closes on Escape, click outside,
 * or the header close button. Header shows a title + close; body is your content.
 *
 * Built on Radix Dialog: it owns the behaviour layer — portal to document.body
 * (so the scrim is never trapped by an ancestor stacking context, e.g. a sticky
 * sidebar), focus trap, focus restore to the trigger on close, body scroll lock,
 * Escape and outside-click. We only bring the styling via existing class names.
 *
 * The component is mounted only while visible, so the dialog is permanently `open`;
 * any close intent from Radix is mapped to `onClose`.
 */
export function Modal({ title, onClose, children, className = '' }) {
  const cls = ['modal', className].filter(Boolean).join(' ')
  return (
    <Dialog.Root
      open
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose && onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="modal-backdrop" />
        {/* aria-describedby={undefined} — нет Dialog.Description, гасим dev-warning */}
        <Dialog.Content
          className={cls}
          aria-describedby={undefined}
          onInteractOutside={(event) => {
            // Подтверждение (AlertDialog) ложится поверх модалки. Клик по его кнопкам
            // не должен закрывать саму модалку.
            const target = event.detail.originalEvent.target
            if (target instanceof Element && target.closest('[role="alertdialog"]')) {
              event.preventDefault()
            }
          }}
        >
          <div className="modal-head">
            <Dialog.Title asChild>
              <h2>{title}</h2>
            </Dialog.Title>
            <Dialog.Close asChild>
              <button className="icon-btn" aria-label="Закрыть">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </Dialog.Close>
          </div>
          <div className="modal-body">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
